var map = {
	"./blocks.png": 3484,
	"./books-blue.png": 598,
	"./books.png": 3485,
	"./cancel-blue.png": 599,
	"./cancel.png": 3486,
	"./clock-blue.png": 600,
	"./clock.png": 3487,
	"./confetti.png": 3488,
	"./flag-blue.png": 601,
	"./flag.png": 3489,
	"./gauge-blue.png": 602,
	"./gauge.png": 3490,
	"./gear.png": 3491,
	"./lightbulb-blue.png": 603,
	"./lightbulb.png": 3492,
	"./magnifier-white.png": 3493,
	"./open-book-white.png": 3494,
	"./pencil.png": 3495,
	"./question-and-answer.png": 3496,
	"./rising-blue.png": 604,
	"./rising.png": 3497,
	"./settings-gears-white.png": 3498,
	"./slow.png": 3499,
	"./star.png": 3500,
	"./target.png": 3501,
	"./writing-white.png": 3502
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 356;



//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons ^\.\/.*\.png$
// module id = 356
// module chunks = 0